import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/shared/services/data.service';
import { FormControl, FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ToastrService } from 'ngx-toastr';
import { Cols } from 'src/app/shared/models/cols';
import { MailFileDto } from 'src/app/shared/interfaces';
import { FilesService } from 'src/app/shared/services/files.service';
import { IButton, TranslateService } from '@devinforius/i-essentials';

@Component({
  selector: 'app-assign-attachments-modal',
  templateUrl: './assign-attachments-modal.component.html',
  styleUrls: ['./assign-attachments-modal.component.scss'],
})
export class AssignAttachmentsComponent implements OnInit {
  public filesNames: string[] = [];

  public titleButtons: IButton[] = [
    {
      text: 'global.quit',
      styleClass: 'blue',
      click: () => {
        this.close();
      },
    },
    {
      text: 'valid',
      styleClass: 'green',
      disabled: this.filesNames.length === 0 ? true : false,
      click: () => {
        this.submit();
      },
    },
  ];

  public form = new FormGroup({
    attachmentsIds: new FormControl(null),
  });
  public courrierID: number;
  public filesArray: { id: number; name: string }[] = [];
  public filesIds: number[] = [];
  public columns: Cols[] = [
    {
      field: 'id',
      header: 'ID',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
    {
      field: 'name',
      header: 'Nom',
      format: (value) => {
        if (value) {
          return value;
        } else {
          return '/';
        }
      },
    },
  ];
  public forselection = [
    {
      click: (selections) => {
        this.filesIds = [];

        if (selections?.length > 0) {
          selections.map((item) => {
            this.filesIds.push(item.id);
            this.filesNames.push(item.name);
          });
        }
        this.titleButtons[1].disabled = this.filesNames.length === 0 ? true : false;
      },
      label: 'Valider la sélection',
      tooltip: '',
    },
  ];
  public attachementMode = false;
  constructor(
    public dataService: DataService,
    public ref: DynamicDialogRef,
    public dataModal: DynamicDialogConfig,
    public toastr: ToastrService,
    private filesService: FilesService,
    private translater: TranslateService
  ) {}

  ngOnInit(): void {
    this.titleButtons = this.titleButtons.map((button) => ({ ...button, text: this.translater.translate(button.text) }));
    this.courrierID = this.dataModal.data ? this.dataModal.data.courrierID : null;
    this.attachementMode = this.dataModal.data ? this.dataModal.data.attachementMode : null;
    if (this.courrierID) {
      this.getFiles(this.courrierID);
    }
  }

  getFiles(courrierID: number) {
    this.filesService.fetchMailFiles(courrierID).subscribe({
      next: (res: MailFileDto[]) => {
        if (res?.length > 0) {
          res.forEach((item) => {
            this.filesArray.push({
              id: item.id,
              name: item.description,
            });
          });
        } else {
          this.close();
        }
      },
    });
  }

  submit() {
    this.form.value.attachmentsIds = this.filesIds;
    this.ref.close(this.form.value);
  }

  close() {
    this.ref.close({ attachmentsIds: [] });
  }
}
